<template>
  <vx-card no-shadow title="Firm Preferences">
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="Practice Area">
        <h4 class="mt-5">Practice Area</h4>
        <a-list item-layout="horizontal" :data-source="areas">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a slot="actions">Edit</a>
            <a slot="actions">Delete</a>
            <a-list-item-meta>
              <a slot="title" href="#">{{ item.title }}</a>
              <a-avatar
                slot="avatar"
                src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
              />
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </a-tab-pane>
      <a-tab-pane key="2" tab="Matter Numbering" forceRender>
        <div class="flex space-x-4">
          <div class="w-1/2">
            <a-form>
              <a-form-item label="Select template">
                <a-select default-value="lucy" class="select">
                  <a-select-option value="jack">
                    Jack
                  </a-select-option>
                  <a-select-option value="lucy">
                    Lucy
                  </a-select-option>
                  <a-select-option value="Yiminghe">
                    yiminghe
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Customize with additional fields">
                <a-select default-value="lucy" class="select">
                  <a-select-option value="jack">
                    Jack
                  </a-select-option>
                  <a-select-option value="lucy">
                    Lucy
                  </a-select-option>
                  <a-select-option value="Yiminghe">
                    yiminghe
                  </a-select-option>
                </a-select>
              </a-form-item>
              <h5 class="mt-5">Select additional options below</h5>
              <a-form-item label="Format Options">
                <a-select default-value="lucy" class="select">
                  <a-select-option value="jack">
                    Jack
                  </a-select-option>
                  <a-select-option value="lucy">
                    Lucy
                  </a-select-option>
                  <a-select-option value="Yiminghe">
                    yiminghe
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-button type="primary" class="mt-5 rounded self-end">
                Add
              </a-button>
            </a-form>
          </div>
          <div class="w-1/2">
            <p class="font-semibold text-medium">
              Insert separators or type your own below:
            </p>
            <a-card>
              <a-tag color="pink">
                pink
              </a-tag>
              <a-tag color="red">
                red
              </a-tag>
              <a-tag color="orange">
                orange
              </a-tag>
              <a-tag color="green">
                green
              </a-tag>
              <a-tag color="cyan">
                cyan
              </a-tag>
              <p class="mt-5">Click to add additional text</p>
            </a-card>
          </div>
        </div>
      </a-tab-pane>
      <a-button type="primary" slot="tabBarExtraContent" @click="addPractice">
        Add
      </a-button>
    </a-tabs>
    <a-modal :visible="visible" @cancel="onCancel" title="Add Practice Area">

      <a-input v-model="title"/>

      <a-divider/>
      <div class="flex space-x-2">
        <a-button type="primary" @click="AddPracticeArea" style="border-radius: 3px !important;">Save</a-button>
        <a-button type="primary" ghost @click="onCancel" style="border-radius: 3px !important;">Cancel</a-button>
      </div>

    </a-modal>
  </vx-card>
</template>

<script>

    import axios from "@/axios";

    const data = [
      {
        title: 'Administrative',
      },
      {
        title: 'Bankruptcy',
      },
      {
        title: 'Builder s Liens',
      },
      {
        title: 'Business',
      },
    ];
    export default {
        name: "FirmPreferences",
        components:{

        },
        data(){
          return{
            data,
            visible:false,
            title: null,
            areas:[]
          }
        },
        methods:{
          addPractice(){
            this.visible = true
          },
          onCancel(){
            this.visible = false
          },
          async AddPracticeArea(){
            try{
              this.$vs.loading()
              console.log([{ title:this.title },...this.areas],'[{ title:this.title },...this.areas]')
              const { data } = await axios.put('/setting/firm/areas/',{ areas: [{ title:this.title },...this.areas] })
              this.areas = data
              this.$notification['success']({
                message: 'Success',
                description: `firm preferences success.`,
              });
              this.visible = false
              await this.getOneFirmPractice()
            }catch (e) {
              this.$notification['error']({
                message: 'Failed',
                description: `firm preferences failed.`,
              });
            }finally {
              this.$vs.loading.close()
            }
          },
          async getOneFirmPractice(){
            try{
              this.$vs.loading()
              const { data } = await axios.get('/setting/firm/areas/')
              this.areas = [...data,...this.areas]
              console.log(data,'fffffffffff')
            }catch (e) {
              this.$message.error('Error receiving data.')
            }finally {
              this.$vs.loading.close()
            }
          },
        },
        mounted() {
          this.getOneFirmPractice()
        }
    }
</script>

<style>
  [dir=ltr] .ant-modal-footer{
    text-align: left !important;
    direction: rtl !important;
  }
  .ant-btn.ant-btn-primary{
    /*margin-right: 0.5em;*/
  }
</style>
